export const estados = {
  PU: 'Publicado',
  IN: 'Iniciado',
  FI: 'Finalizado',
  CE: 'Cerrado',
  RZ: 'Rechazado',
  PE: 'Pendiente',
  AN: 'Anulado',
};
